import { BadgeClassKey } from '@material-ui/core/Badge';
import { Theme } from '@material-ui/core/styles';

const MuiBadge = (theme: Theme): Partial<Record<BadgeClassKey, unknown>> => {
    const backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[600];

    return {
        badge: {
            backgroundColor,
        },
    };
};

export default MuiBadge;
